import React, { Fragment }  from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaLicEncerradas from '../../components/licitacao/listar';
import ItemBox from '../../components/shared/item_box';

function LicsEncerradasScreen() {
    return (
        <Fragment>
            <Head titulo="Licitações Encerradas do Município de Macuco" />
            <Header />
            <Container>
                <Row>
                    {/* Coluna lateral - ItemBox (fica em cima no mobile, direita no desktop) */}
                    <Col xs={{span: 12, order: 1}} md={{span: 4, order: 2}}>
                        <ItemBox
                            titulo={"NOTA INFORMATIVA"}
                            texto={
                                <Fragment>
                                    <p>
                                        MUNICÍPIO DE MACUCO, faz saber a todos, que os participantes do processo licitatório e de dispensa para ingresso nos respectivos certames, deverão declarar não possuir parentesco, em linha reta, colateral ou por afinidade, até o terceiro grau, com servidores ou agentes políticos envolvidos no processo licitatório ou dispensa e com poder decisório capaz de influenciar o resultado, independentemente da modalidade de contração.
                                    </p>
                                    <br />
                                </Fragment>
                            }
                            link={"https://prefeituramacuco.rj.gov.br/transparencia/arquivos/docs/nota-licitacao.pdf"}
                        />
                    </Col>

                    {/* Coluna principal - Licitações */}
                    <Col xs={{span: 12, order: 2}} md={{span: 8, order: 1}}>
                        <ListaLicEncerradas />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}
export default LicsEncerradasScreen;